import { IStepOption } from 'ngx-ui-tour-ngx-bootstrap';

const isMx = true;
const isUsa = true;

export const coachmarks = {
  onboarding: { usa: 'trading_onboarding_usa', mx: 'trading_onboarding_mx' },
  footbar: {
    market: 'footbar-coachmark-market',
  },
};

export interface CoachmarkTour {
  mainAnchorId: string;
  eventAnchorId: string;
  /**
   * When the tour being declared is disabled, should other coachmarks be disabled?
   * For example, if we have feature tours that are a subset of bigger tour, those
   * feature tours should be disabled when watching the bigger tour.
   */
  toursToDisable?: string[];
  /**
   * When the tour should be displayed one per strategy, (for example, if I have
   * multiple TMX strategies, it'll be displayed in each one, even after the user has
   * seen it in other ones).
   *
   * By default (when this is false), the user will only see the tour one time,
   * independently of the number of strategies.
   */
  isOnePerContract?: boolean;
  isMultilineTitle?: boolean;
  /**
   * When adding a step, as a best-practice, you should not only create an element
   * with the corresponding `anchorId` as a `tourAnchor`, but also a `data-tour-anchor`
   * attribute, as it will have a more predictable behavior when manually checking
   * for the existance of `tour-anchors`.
   *
   * Check existing implementations for reference, and
   * CoachmarkService.checkExistanceOfStepAnchorInDom() for context.
   */
  steps: Array<IStepOption>;
  isUsa?: boolean;
  isMx?: boolean;
}

const onboardingMxSteps: (IStepOption & {
  isUsa?: boolean;
  isMx?: boolean;
})[] = [
  {
    anchorId: 'balance-actions-deposit',
    content: `Consulta los datos para depositar a tu estrategia`,
    placement: 'bottom',
    isUsa,
    isMx,
  },
  {
    anchorId: 'markets-coachmark-navbar',
    content: `Encuentra, agrega y/o actualiza la lista de tus instrumentos favoritos`,
    placement: 'bottom',
    isUsa,
    isMx,
  },
  {
    anchorId: 'news-coachmark-navbar',
    content: `Mantente informado con las últimas noticias`,
    placement: 'bottom',
    isMx,
  },
  {
    anchorId: 'funds-coachmark-navbar',
    content: `Conoce el detalle de los diferentes fondos de inversión`,
    placement: 'bottom',
    isMx,
  },
  {
    anchorId: 'analysis-coachmark-navbar',
    content: `Consulta la información detallada que te brindan los expertos`,
    placement: 'bottom',
    isMx,
  },
  {
    anchorId: 'movements-coachmark-navbar',
    content: `Lleva el control de tus órdenes y movimientos de efectivo`,
    placement: 'bottom',
    isUsa,
  },
  {
    anchorId: 'orders-coachmark-navbar',
    content: `Lleva el control de tus órdenes y movimientos de efectivo`,
    placement: 'bottom',
    isMx,
  },
  {
    anchorId: 'performance-coachmark-navbar',
    content: `Visualiza la rentabilidad de tu portafolio considerando los precios de cierre oficiales`,
    placement: 'bottom',
    isUsa,
  },
  {
    anchorId: 'tools-coachmark-navbar',
    content: `Visualiza la rentabilidad de tu portafolio considerando los precios de cierre oficiales`,
    placement: 'bottom',
    isMx,
  },
  {
    anchorId: 'documents-coachmark-navbar',
    content: `Descarga los documentos que te facilitamos de tus inversiones`,
    placement: 'bottom',
    isMx,
  },
  {
    anchorId: 'bank-accounts-coachmark-navbar',
    content: `Agrega y visualiza las cuentas que tienes registradas para realizar retiros o transferencias`,
    placement: 'bottom',
    isMx,
  },
];

export const GLOBAL_COACHMARK_STEPS: CoachmarkTour[] = [
  /**
   * First (chronologically) coachmarks tours have a difference between mainAnchorId
   * and eventAnchorId name but in the future, tours will have same value for those keys.
   */
  {
    mainAnchorId: coachmarks.onboarding.mx,
    eventAnchorId: coachmarks.onboarding.mx,
    isMx,
    steps: onboardingMxSteps.filter((e) => e.isMx),
    isOnePerContract: true,
  },
  {
    mainAnchorId: coachmarks.onboarding.usa,
    eventAnchorId: coachmarks.onboarding.usa,
    isUsa,
    steps: onboardingMxSteps.filter((e) => e.isUsa),
    isOnePerContract: true,
  },
  {
    mainAnchorId: coachmarks.footbar.market,
    eventAnchorId: coachmarks.footbar.market,
    isMx,
    isUsa,
    isMultilineTitle: true,
    steps: [
      {
        anchorId: coachmarks.footbar.market,
        title: '¡Nuevo!',
        content: `Visualiza de forma rápida si el mercado está abierto o cerrado`,
        placement: 'bottom',
      },
    ],
  },
];
